/* eslint-disable */
import $http from "@/utils/http.ts";
import { Result } from "@/model/system";

export default class Service {
  name: string;
  root: string;
  constructor(name = "", root = "/api") {
    this.name = name;
    this.root = root;
  }

  format(name: string, path: string) {
    return [this.root, name, path].join("/").replace("//", "/");
  }

  get<T>(path: string, options?: any): Promise<Result<T>> {
    const url = this.format(this.name, path);
    return $http.ajax(url, "", "get", options);
  }

  post<T>(path: string, data: any, options?: any): Promise<Result<T>> {
    // for (const d in data) {
    //     if (data[d] instanceof Date) {
    //         data[d] = (<any>window).moment(data[d]).format("YYYY-MM-DD HH:mm:ss");
    //     }
    // }
    const url = this.format(this.name, path);
    return $http.ajax(url, JSON.stringify(data), "post", options);
  }
}
